import { IFeature } from '../interfaces/IFeature';

export const getFeatureFlag = (feature: IFeature | undefined, flag: string): boolean => {
    if (feature) {
        if (feature[flag] !== undefined) {
            return feature[flag];
        }
    }
    return false;
}